import React, { useState } from 'react';
import { X, Send, Mail, User, Building, MessageSquare } from 'lucide-react';
import { useToast } from '../hooks/use-toast';

const ContactModal = ({ isOpen, onClose }) => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Mock submission
    setTimeout(() => {
      toast({
        title: "Message Sent!",
        description: "Thank you! We'll get back to you within 24 hours."
      });
      setFormData({ name: '', email: '', company: '', message: '' });
      setIsSubmitting(false);
      onClose();
    }, 1000);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>

        <div className="modal-header">
          <h2 className="heading-3 text-primary mb-2">Quick Contact</h2>
          <p className="body-medium text-text-secondary">
            Send us a message and we'll respond within 24 hours
          </p>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="modal-name" className="form-label">
              <User size={18} /> Name *
            </label>
            <input
              type="text"
              id="modal-name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              className="form-input"
              placeholder="Your full name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="modal-email" className="form-label">
              <Mail size={18} /> Email *
            </label>
            <input
              type="email"
              id="modal-email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="form-input"
              placeholder="your.email@company.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="modal-company" className="form-label">
              <Building size={18} /> Company
            </label>
            <input
              type="text"
              id="modal-company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              className="form-input"
              placeholder="Your company name"
            />
          </div>

          <div className="form-group">
            <label htmlFor="modal-message" className="form-label">
              <MessageSquare size={18} /> Message *
            </label>
            <textarea
              id="modal-message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows="4"
              className="form-input form-textarea"
              placeholder="Tell us about your project..."
            ></textarea>
          </div>

          <button
            type="submit"
            disabled={isSubmitting}
            className="btn-primary w-full btn-glow"
          >
            {isSubmitting ? 'Sending...' : 'Send Message'}
            <Send size={20} className="ml-2" />
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;